export default __webpack_public_path__ + "static/media/grimcorruption1.0be819e2.png";